import React from 'react';
import PropTypes from 'prop-types';

const TextWrapper = ({ className, limit, text, dotted, seoTag, sliceLimit }) => {
  const textLength = text?.length;
  let slicedText = text;

  if (textLength > limit) {
    slicedText = text.slice(0, sliceLimit ?? limit) + (dotted ? '...' : '');
  }


  switch (seoTag) {
    case 'h2':
      return <h2 className={ className }>{ slicedText }</h2>;
    case 'h3':
      return <h3 className={ className }>{ slicedText }</h3>;

    default:
      return <span className={ className }>{ slicedText }</span>;
  }
};

TextWrapper.propTypes = {
  className: PropTypes.string,
  limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  dotted: PropTypes.bool,
  seoTag: PropTypes.string,
  sliceLimit: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

TextWrapper.defaultProps = {
  text: '',
  limit: 13,
  dotted: false,
  seoTag: '',
  sliceLimit: undefined
};

export default TextWrapper;

